module.exports = __webpack_public_path__ + "static/media/AboutMe.88761e67.png";